import React from 'react';

import TableRow from './TableRow';

function InvoiceAdditionsTable(props) {
  const { additionalsList = [], pageNumber, pageSize } = props;

  return (
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          <th className="text-center">{locales('tables.row')}</th>
          <th className="text-center ">{locales('tables.title')}</th>
          <th className="text-center">{locales('messages.quantity')}</th>
          <th className="text-center">{locales('tables.showable')}</th>
          <th className="text-center">{locales('tables.activated')}</th>
          <th className="text-center">{locales('tables.registrar')}</th>
          <th className="text-center">{locales('tables.creationDate')}</th>
          <th className="text-center" colSpan="2"></th>
        </tr>
      </thead>
      <tbody>
        {additionalsList && additionalsList.length ? 
          additionalsList.map((additional, index) => (
            <TableRow
              key={additional.id}
              ix={index}
              id={additional.id}
              pageNumber={pageNumber}
              pageSize={pageSize}
              title={additional.title}
              value={additional.value}
              currency={additional.currency}
              isPercent={additional.isPercent}
              showOnFactor={additional.showOnFactor}
              isActive={additional.isActive}
              createdFullName={additional.createdFullName}
              createdAt={additional.createdAt}

              toggleStatus={props.toggleStatus}
              displayDeleteModal={props.displayDeleteModal}
            />
        )) : (
          <tr className="col-12 text-center">
            <td className="alert alert-info" colSpan={12}>
              {locales('alerts.noRecord')}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default InvoiceAdditionsTable;
